import * as React from "react";

import { JSX } from "react/jsx-runtime";

const BreifCaseIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={27}
    height={26}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="briefcase-02">
      <path
        id="Vector"
        d="M3.29444 9.3438C3.21785 8.70489 3.17955 8.38542 3.23342 8.12392C3.38711 7.37766 4.04362 6.77256 4.91852 6.57073C5.22511 6.5 5.61 6.5 6.37978 6.5H20.62C21.3898 6.5 21.7747 6.5 22.0813 6.57073C22.9562 6.77256 23.6127 7.37766 23.7665 8.12392C23.8203 8.38542 23.7819 8.70489 23.7054 9.3438C23.5299 10.8081 22.7073 11.609 21.1387 12.0708L16.6199 13.4012C15.0752 13.8559 14.3028 14.0833 13.4999 14.0833C12.6971 14.0833 11.9246 13.8559 10.3799 13.4012L5.86114 12.0708C4.2926 11.6091 3.46998 10.8081 3.29444 9.3438Z"
        stroke="black"
        strokeWidth={1.625}
      />
      <path
        id="Vector_2"
        d="M4.2514 11.375L4.03879 13.8403C3.65771 18.2596 3.46716 20.4693 4.68962 21.8805C5.91207 23.2917 8.01672 23.2917 12.226 23.2917H14.774C18.9833 23.2917 21.0879 23.2917 22.3104 21.8805C23.5329 20.4693 23.3423 18.2596 22.9612 13.8403L22.7486 11.375"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M17.2916 5.95831L17.2078 5.67133C16.7908 4.24128 16.5822 3.52626 16.0857 3.11729C15.5892 2.70831 14.9298 2.70831 13.6107 2.70831H13.3891C12.07 2.70831 11.4106 2.70831 10.9141 3.11729C10.4176 3.52626 10.2091 4.24128 9.79196 5.67133L9.70825 5.95831"
        stroke="black"
        strokeWidth={1.625}
      />
    </g>
  </svg>
);
export default BreifCaseIcon;
